import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SidebarNav from './SidebarNav';

interface SidebarProps {
    collapsed: boolean;
    onToggle: () => void;
}

/**
 * The application sidebar.
 *
 * Both this and the /modules launcher render from `MODULE_CATALOG` and `useModuleVisibility`, so a
 * page is reachable from both surfaces or neither — there is no second copy of the permission
 * rules to keep in step. A module with several reachable pages renders as a collapsible menu; one
 * with a single reachable page renders as a plain link straight to it.
 */
const Sidebar = ({ collapsed, onToggle }: SidebarProps) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="sidebar" style={{ width: collapsed ? '60px' : '250px' }}>
            <div className="logo">
                <div className="logo-inner">
                    {!collapsed && <h2>OMS</h2>}
                    <IconButton onClick={onToggle} className="sidebar-toggle" size="small">
                        {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
            </div>
            <SidebarNav collapsed={collapsed} />
            <div className="logout-section">
                <button onClick={handleLogout} className={`logout-button ${collapsed ? 'collapsed' : ''}`} title={collapsed ? 'Logout' : ''}>
                    <span className="icon" style={{ marginRight: collapsed ? 0 : undefined }}>🚪</span>
                    {!collapsed && 'Logout'}
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
